import React from 'react';

export default function Pager({ page, pages, total, onPage, label = 'records' }) {
  if (!pages || pages <= 1) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: '1rem', fontSize: 13 }}>
      <button className="btn btn-sm" onClick={() => onPage(page - 1)} disabled={page <= 1}>
        <i className="ti ti-chevron-left" aria-hidden="true"></i>Prev
      </button>
      <span>Page {page} of {pages}&nbsp;·&nbsp;{total} {label}</span>
      <button className="btn btn-sm" onClick={() => onPage(page + 1)} disabled={page >= pages}>
        Next<i className="ti ti-chevron-right" aria-hidden="true"></i>
      </button>
    </div>
  );
}
